import { string } from 'yup'

export default string()
  .required()
  .matches(/^0[0-9]{9}$/, 'Not a valid french phone number')
